function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Icon } from "@iconify/react";
import { Nurse, Inpatient, RuralPost, Breasts, DoctorFemale, Admissions, Radiology, BiochemistryLaboratory, UltrasoundScanner, Tac, CrisisResponseCenterPerson } from 'healthicons-react';
import { Power, HouseFill, BuildingFillGear, ImageFill, Broadcast, CollectionFill, Eyedropper, GearWideConnected, PersonBoundingBox, MagnetFill, FileBreak, CashStack, BoxSeamFill, Speedometer, Clipboard2PulseFill, Building, PeopleFill, GearFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();
  var _useState = useState('day'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
    handleMenuClose();
  };
  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    onClick: handleClick,
    style: {
      background: "#FCFCFC"
    },
    selectedKeys: current,
    theme: "light",
    mode: "vertical",
    children: [(Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "flat-color-icons:statistics",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/dashboard",
        children: /*#__PURE__*/_jsx("b", {
          children: "Tab. de bord"
        })
      })
    }, "dash"), (Common.currentUser.role == 99 || Common.currentUser.role == 11) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "flat-color-icons:home",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/cashier",
        children: /*#__PURE__*/_jsx("b", {
          children: "Accueil"
        })
      })
    }, "day"), (Common.currentUser.role == 99 || Common.currentUser.role == 71) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "medical-icon:laboratory",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/laboratoire",
        children: /*#__PURE__*/_jsx("b", {
          children: "Laboratoire"
        })
      })
    }, "lab"), (Common.currentUser.role == 99 || Common.currentUser.role == 31 || Common.currentUser.role == 32) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "fa-solid:user-md",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/consultations",
        children: /*#__PURE__*/_jsx("b", {
          children: "Consultation"
        })
      })
    }, "cons"), (Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "medical-icon:i-imaging-root-category",
        width: "32",
        height: "32"
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Imagerie"
      }),
      children: [(Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:ultrasound",
          width: "32",
          height: "32"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/echographie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Echographie"
          })
        })
      }, "echo"), (Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Radiology, {
          width: 32,
          height: 32
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/radiologie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Radiographie"
          })
        })
      }, "radio"), (Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:mri-pet",
          width: "32",
          height: "32"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/scanner",
          children: /*#__PURE__*/_jsx("b", {
            children: "Scanner"
          })
        })
      }, "scan"), (Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:imaging-alternative-mri",
          width: "32",
          height: "32"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/irm",
          children: /*#__PURE__*/_jsx("b", {
            children: "IRM"
          })
        })
      }, "irm"), (Common.currentUser.role == 99 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:i-mammography",
          width: "32",
          height: "32"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/mammographie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Mammographie"
          })
        })
      }, "mammo")]
    }, "exp"), (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 11) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "medical-icon:elevators",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/attendance",
        children: /*#__PURE__*/_jsx("b", {
          children: "Ambulatoire"
        })
      })
    }, "freq"), (Common.currentUser.role == 99 || Common.currentUser.role == 41 || Common.currentUser.role == 51 || Common.currentUser.role == 31 || Common.currentUser.role == 32) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "medical-icon:i-intensive-care",
        width: "32",
        height: "32"
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Hospitalisations"
      }),
      children: [(Common.currentUser.role == 99 || Common.currentUser.role == 41) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:i-inpatient",
          width: "32",
          height: "32",
          fill: "#CBDFB8"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/hospitalization",
          children: /*#__PURE__*/_jsx("b", {
            children: "Sommaire"
          })
        })
      }, "bedsshort"), (Common.currentUser.role == 99 || Common.currentUser.role == 41 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "healthicons:admissions",
          width: "32",
          height: "32",
          fill: "#CBDFB8"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/hospitalization/rooms",
          children: /*#__PURE__*/_jsx("b", {
            children: "Gestion des salles"
          })
        })
      }, "beds"), (Common.currentUser.role == 99 || Common.currentUser.role == 31 || Common.currentUser.role == 32) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:care-staff-area",
          width: "32",
          fill: "#CBDFB8",
          height: "32"
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/hospitalization/care",
          children: /*#__PURE__*/_jsx("b", {
            children: "Soins m\xE9dicaux"
          })
        })
      }, "care")]
    }, "hosp"), (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 61 || Common.currentUser.role == 81) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "medical-icon:hospital",
        width: "32",
        height: "32",
        color: "#F57C00"
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Administration"
      }),
      children: [(Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(BoxSeamFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/consumables",
          children: /*#__PURE__*/_jsx("b", {
            children: "Consommables"
          })
        })
      }, "cons"), (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 81) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(PeopleFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/hr",
          children: /*#__PURE__*/_jsx("b", {
            children: "Res. Humaines"
          })
        })
      }, "rh"), (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(CashStack, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/facturation",
          children: /*#__PURE__*/_jsx("b", {
            children: "Finances"
          })
        })
      }, "fact"), (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Building, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/companies",
          children: /*#__PURE__*/_jsx("b", {
            children: "Soci\xE9t\xE9s"
          })
        })
      }, "comps"), (Common.currentUser.role == 99 || Common.currentUser.role == 98) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(GearWideConnected, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/departments",
          children: /*#__PURE__*/_jsx("b", {
            children: "Configurations"
          })
        })
      }, "Depts")]
    }, "adm"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "flat-color-icons:conference-call",
        width: "37",
        height: "34"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users",
        children: /*#__PURE__*/_jsx("b", {
          children: "Utilisateurs"
        })
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: "flat-color-icons:services",
        width: "32",
        height: "32"
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig",
        children: /*#__PURE__*/_jsx("b", {
          children: "Mon compte"
        })
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: 'EA696B',
          fontWeight: "bold"
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "#",
        children: /*#__PURE__*/_jsx("b", {
          children: "D\xE9connexion"
        })
      })
    }, "quit")]
  });
};
export default UserNavBar;